import { SelectOption } from 'basics/options/options.types';
import { HostProvider } from 'generated/event.types';

const eventHostProviderOptions: SelectOption[] = [
  { id: HostProvider.zoom, label: 'Zoom Meeting' },
  { id: HostProvider.other, label: 'Existing link' },
];

export default eventHostProviderOptions;
